module.exports = __webpack_public_path__ + "img/confetti_2c.f199d666.svg";